import { render, staticRenderFns } from "./NpaKeywords.vue?vue&type=template&id=58931a16"
import script from "./NpaKeywords.vue?vue&type=script&lang=js"
export * from "./NpaKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports